export const parseStoredPermissions = () => {
  try {
    const stored = localStorage.getItem("permissions");
    if (!stored) return [];
    const parsed = JSON.parse(stored);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

const deniedPermissions = () => {
  try {
    const overrides = JSON.parse(localStorage.getItem("permissionOverrides") || "{}");
    return Object.keys(overrides).filter((key) => overrides[key] === "deny");
  } catch {
    return [];
  }
};

export const mergeGrantedPermissions = (permissions = [], userPermission = []) => {
  const denied = deniedPermissions();
  return Array.from(new Set([...permissions, ...userPermission, ...parseStoredPermissions()]))
    .filter((key) => !denied.includes(key)
      && !(denied.length && key === "access.system.full_access"));
};

export const hasPermission = (grantedPermissions = [], ...requiredPermissions) => {
  const denied = deniedPermissions();
  return requiredPermissions
    .flat()
    .filter(Boolean)
    .some((permission) => !denied.includes(permission)
      && (grantedPermissions.includes(permission)
        || grantedPermissions.includes("access.system.full_access")));
};
// Use this only where a server-issued permission must be explicitly present.
// `full_access` remains supported by the legacy helper above, but must not
// override an effective denial for sensitive, newly introduced UI actions.
export const hasExplicitPermission = (grantedPermissions = [], ...requiredPermissions) =>
  requiredPermissions
    .flat()
    .filter(Boolean)
    .some((permission) => !deniedPermissions().includes(permission)
      && grantedPermissions.includes(permission));
